<template>
  <VAutocomplete
      data-test="findAddressField"
      :items="addressList"
      :loading="isLoading"
      :searchInput="selectedAddress"
      hideNoData
      solo
      clearable
      hideSelected
      itemText="address"
      class="pb-0"
      :filter="e => e"
      hideDetails
      itemValue="id"
      :placeholder="$t('bookingForm.searchAddressTitle')"
      prependInnerIcon="mdi-magnify"
      returnObject
      @update:search-input="searchAddress"
      @change="selectAddress"
  />
</template>

<script lang="ts">
export default {
  name: 'AddressSearch',
};
</script>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { determiningSelectedQuery, getGeoCodeByGoogleApi } from '@slg/web-customer-shared/src/providers/MapProvider';

defineProps({
  selectedAddress: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['selectAddress']);

const addressList = ref([]);
const isLoading = ref(false);
const search = ref('');
const cancelSource = ref(null);

watch(search, (e) => {
  searchAddress(e);
});

async function selectAddress(data) {
  if (!data) {
    return;
  }
  if (data.isGoogleApi) {
    const { lat, lon } = await getGeoCodeByGoogleApi(data.id);
    const dataToSet = {
      lat,
      lon,
      id: data.id,
      address: data.address,
    };
    emit('selectAddress', dataToSet);
    return;
  }

  const dataToSet = {
    lat: data.geocode[1],
    lon: data.geocode[0],
    address: data.address,
  };
  emit('selectAddress', dataToSet);
}

async function searchAddress(value) {
  if (!value) {
    addressList.value = [];
    return;
  }
  isLoading.value = true;

  // if (this.cancelSource) {
  //   this.cancelSource.cancel();
  // }
  // this.cancelSource = axios.CancelToken.source();

  addressList.value = await determiningSelectedQuery(value);
  isLoading.value = false;
}
</script>

<style lang="scss">
@import "@slg/web-customer-shared/src/style/variables.scss";

.v-list-item__title {
  font-size: $fs-14 !important;
  .v-list-item__mask {
    font-weight: $fw-700 !important;
    background: transparent !important;
    color: var(--v-textPrimary-base) !important;
  }
}
</style>
